import _ from 'lodash';
import axios from 'axios';

const imagesCache = {};

function preloadImage(element, src, selector) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function() {
            resolve({element, img});
        };
        img.onerror = img.onabort = function() {
            reject({element});
        };

        const cachedImage = _.get(imagesCache, src);
        if (cachedImage) {
            img.src = cachedImage;
            _.set(element, selector, cachedImage);
        } else if (!src.includes('blob') || (src.includes('blob') && src.includes('amazonaws.com'))) {
            axios.get(src, {
                responseType: 'blob',
                anonymous: src.includes('amazonaws.com'),
                headers: {
                    'Cache-Control': 'no-cache',
                },
            }).then(image => {
                const blobSrc = URL.createObjectURL(image.data);
                img.src = blobSrc;
                _.set(element, selector, blobSrc);
                _.set(imagesCache, src, blobSrc);
            }).catch(() => {
                img.src = '';
                console.warn('Unable to load image: ', src);
            });
        } else {
            img.src = src;
        }
    });
}

export async function preloadImages(collection, selectors, finishLoading) {
    if (collection.length === 0) {
        finishLoading();
        return;
    }
    for (let selector of selectors) {
        const elementsWithImages = collection.filter(element => _.get(element, selector));
        const imagesPromises = elementsWithImages.map(element => preloadImage(element, _.get(element, selector), selector));
        await Promise.allSettled(imagesPromises).then(results => {
            results.forEach(result => {
                if (result.status === 'fulfilled') {
                    _.set(result, selector, result.value.img.src);
                }
            });
        });
    }
    finishLoading();
}


// WEBPACK FOOTER //
// ./src/common/ImageLoadHelper.js